export type CollectionSubtype = typeof collectionSubtypes[number];
export const collectionSubtypes = [
  'CHEST',
  'CRATE',
  'PALLET',
  'CARTON_OR_BOX',
  'SHRINK',
  'TRAY',
  'OTHER',
] as const;

export type StandaloneSubtype = typeof standaloneSubtypes[number];
export const standaloneSubtypes = [
  'BOTTLE',
  'BOX',
  'PLASTIC_BOTTLE',
  'BARREL',
  'KEY_KEG',
  'JUG',
  'CANISTER',
  'CLOSING',
  'BAG_IN_BOX',
  'OTHER',
] as const;
